import React from 'react';
import type { NextPage } from 'next';
import { getOrCreateStore, type ReduxInitialProps } from 'stores';

import WindStationMap from 'containers/WindStationMap';

const WindStationMapPage: NextPage<
  {},
  ReduxInitialProps & { isMapV2Page: true; mapMode: 'windStation' }
> = () => <WindStationMap />;

WindStationMapPage.getInitialProps = async (context) => {
  const isServer = !!context.req;

  if (isServer) {
    const store = getOrCreateStore();
    return {
      enableCssBaseline: true,
      enableTheme: true,
      isAppBannerEnabled: true,
      isFooterVisible: false,
      isMapV2Page: true,
      mapMode: 'windStation',
      ssrReduxState: store.getState(),
    };
  }

  return {
    enableCssBaseline: true,
    enableTheme: true,
    isAppBannerEnabled: true,
    isFooterVisible: false,
    isMapV2Page: true,
    mapMode: 'windStation',
  };
};

export default WindStationMapPage;
